var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZoom({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8.7c0-2.52 0-3.78.49-4.743A4.5 4.5 0 013.957 1.99C4.92 1.5 6.18 1.5 8.7 1.5h6.6c2.52 0 3.78 0 4.743.49a4.5 4.5 0 011.966 1.967c.491.963.491 2.223.491 4.743v6.6c0 2.52 0 3.78-.49 4.743a4.5 4.5 0 01-1.967 1.966c-.963.491-2.223.491-4.743.491H8.7c-2.52 0-3.78 0-4.743-.49a4.5 4.5 0 01-1.967-1.967C1.5 19.08 1.5 17.82 1.5 15.3V8.7z",
    fill: "#4087FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 7.5c-.525 0-.95.48-.95 1.071v5.197c0 1.509 1.085 2.732 2.423 2.732l5.627-.053c.525 0 .95-.48.95-1.072v-5.25c0-1.509-1.287-2.625-2.625-2.625H6.2zM15.534 9.546c-.34.335-.534.82-.534 1.329v2.174c0 .51.195.994.534 1.33l2.113 1.86c.43.425 1.103.081 1.103-.564V8.351c0-.644-.674-.989-1.103-.564l-2.113 1.759z",
    fill: "#fff"
  })));
}

export default SvgZoom;